/**Modulo abilitabile tramite la licenza per il dispositivo */
export enum LicenseModuleEnum {
    /**Nessuno */
    None = 0x0000,

    /**Tutti i moduli */
    All = 0xffff,

    /**Integrazione */
    Integration = 0x0001,

    /**Gestione service e aggiornamenti */
    ServiceAndUpdatesManagement = 0x0002,

    /**Statistiche fitness */
    FitnessStatistics = 0x0004,

    /**Gestione cash-flow */
    CashFlowManagement = 0x0008,

    /**Gestione parametri di sicurezza e cifratura del protocollo */
    SecurityManagement = 0x0010,

    /* Manutenzione predittiva e analisi log */
    PredictiveMaintenance = 0x0020,

    /* Collegamento remoto con tunnel agente */
    RemoteLink = 0x0040,

    /* Gestione codici dinamici */
    OneTimeCode = 0x0080,

    /* Gestione dataflow */
    DataFlow = 0x0100,
}

export function defaultLicenseModuleEnumSorting(): LicenseModuleEnum[] {
    let res: LicenseModuleEnum[] = [];
    res.push(LicenseModuleEnum.ServiceAndUpdatesManagement);
    res.push(LicenseModuleEnum.RemoteLink);
    res.push(LicenseModuleEnum.PredictiveMaintenance);
    res.push(LicenseModuleEnum.OneTimeCode);
    res.push(LicenseModuleEnum.CashFlowManagement);
    res.push(LicenseModuleEnum.SecurityManagement);
    res.push(LicenseModuleEnum.FitnessStatistics);
    res.push(LicenseModuleEnum.DataFlow);
    return res;
}

export function convertByEnumName(num: number): LicenseModuleEnum {
    let res = LicenseModuleEnum.None;
    Object.keys(LicenseModuleEnum).forEach((k) => {
        if ((LicenseModuleEnum[k] & num) == LicenseModuleEnum[k]) res |= LicenseModuleEnum[k];
    });

    return res as LicenseModuleEnum;
}

export function getLicenseModuleLabel(licenseModule: LicenseModuleEnum | string): string {
    switch (licenseModule) {
        case LicenseModuleEnum.Integration:
            return "common.license_module.integration";
        case LicenseModuleEnum.ServiceAndUpdatesManagement:
            return "common.license_module.service_and_updates_management";
        case LicenseModuleEnum.CashFlowManagement:
            return "common.license_module.cash_flow_management";
        case LicenseModuleEnum.FitnessStatistics:
            return "common.license_module.fitness_statistics";
        case LicenseModuleEnum.SecurityManagement:
            return "common.license_module.security_management";
        case LicenseModuleEnum.PredictiveMaintenance:
            return "common.license_module.predictive_maintenance";
        case LicenseModuleEnum.RemoteLink:
            return "common.license_module.remote_link";
        case LicenseModuleEnum.OneTimeCode:
            return "common.license_module.one_time_code";
        case LicenseModuleEnum.DataFlow:
            return "common.license_module.dataflow";
        case LicenseModuleEnum.None:
            return "common.license_module.none";
        default:
            return "common.unknown";
    }
}
